import { Routes, Route, Navigate } from "react-router-dom";
import AdminPages from "./presentations/pages/AdminPage";
import { useAuth } from "./presentations/context/AuthContext";
import LoginPage from "./presentations/pages/LoginPage/Login";
import LoadingPage from "./presentations/components/LoadingPage";
import { useItemsContext } from "./presentations/context/AppItemsContext";
import { useToppingContext } from "./presentations/context/AppToppingContext";
import { useSaleInfoContext } from "./presentations/context/AppSaleInfoContext";
import { LIMIT_PER_PAGE, PRIVILEGE_ROLE_ENUM } from "./applications/constants/AppConst";
import usePageState from "./presentations/hooks/usePageState";
import useAsyncEffect from "./presentations/hooks/useAsyncEffect";
import MainUserPage from "./presentations/pages/UserPage";
import {
  getAllItemsUseCase,
  getAllToppingUseCase,
  getItemBestSellerUseCase,
} from "./applications/useCase/ApiUseCase/ItemApiUseCase";
import { getAllSaleInfoUseCase } from "./applications/useCase/ApiUseCase/SaleApiUseCase";
import { AppGlobalProvider } from "./presentations/context/AppGlobalContext";

function App() {
  const { authData, isAuthInitialized } = useAuth();
  const { setItems, setItemBestSeller } = useItemsContext();
  const { setToppings } = useToppingContext();
  const { setSaleInfo } = useSaleInfoContext();
  const { showError } = usePageState();

  // Chỉ kiểm tra các giá trị này sau khi auth đã được khởi tạo
  const isLogin = !!authData?.id;
  const isUseAdmin = authData?.use_admin_site;
  const isAdministratorAccount =
    isLogin &&
    [PRIVILEGE_ROLE_ENUM.ADMINISTRATOR, PRIVILEGE_ROLE_ENUM.EMPLOYEE]?.includes(authData.role);

  async function getAllItems() {
    const res = await getAllItemsUseCase({
      showError,
    });
    if (res) {
      setItems(res);
    }
  }

  async function getItemBestSeller() {
    const res = await getItemBestSellerUseCase({
      showError,
    });
    if (res) {
      setItemBestSeller(res);
    }
  }

  async function getAllToppings() {
    const res = await getAllToppingUseCase({
      showError,
    });
    if (res) {
      setToppings(res);
    }
  }

  async function getAllSaleInfo() {
    const res = await getAllSaleInfoUseCase({
      page: 1,
      limit: LIMIT_PER_PAGE,
    });
    if (res) {
      setSaleInfo(res.data);
    }
  }

  useAsyncEffect(async () => {
    await Promise.all([getAllItems(), getAllSaleInfo(), getAllToppings(), getItemBestSeller()]);
  }, []);

  // Chờ auth được khởi tạo trước khi render routes
  if (!isAuthInitialized) return <LoadingPage />;

  return (
    <Routes>
      {/* Trang login - accessible cho tất cả */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin Pages - chỉ cho administrator và employee */}
      <Route
        path="/admin/*"
        element={
          isAdministratorAccount ? (
            <AppGlobalProvider>
              <AdminPages />
            </AppGlobalProvider>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* User Pages - cho user thường (không phải admin mode) */}
      <Route
        path="/*"
        element={!isUseAdmin ? <MainUserPage /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
}

export default App;
